import src from "IMAGE";
export default { src, width: 920, height: 461, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAIAAAA8r+mnAAAASElEQVR42j2LQQ4AIQgD/f9b1YVFOAiBbdzEnppOpzFNIpKla6mqMb+IiLSqcncwzCiZWScHRIz54LX3vuw3ovdhZpCYGRjjBxCpXNpYZi80AAAAAElFTkSuQmCC"};
